export default __webpack_public_path__ + "static/media/isotype-bg.4dad5c59.png";